/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorActions = require('./sorActions/sorActions');
const sorHelpers = require('./sorHelpers/sorHelpers');

require('./sorComponents/sorSpinner');

(function ($) {
  /**
   * @description SmartOrderRefill constructor
   */
  function SmartOrderRefill() {}

  // SmartOrderRefill.initUpdateProductQuantity = sorActions.sorProduct.initUpdateProductQuantity;
  SmartOrderRefill.initRemoveProduct = sorActions.sorProduct.initRemoveProduct;
  // SmartOrderRefill.initUpdateRefill = sorActions.sorProduct.initUpdateRefill;
  SmartOrderRefill.initUpdateQuantityRefill = sorActions.sorProduct.initUpdateQuantityRefill;
  SmartOrderRefill.initProductAvailabilityAlert = sorActions.sorProduct.initProductAvailabilityAlert;
  SmartOrderRefill.initAddProductForm = sorActions.sorAddProductForm.initAddProductForm;
  SmartOrderRefill.initSubscriptionView = sorActions.sorSubscriptionView.initSubscriptionView;
  SmartOrderRefill.initAddressChangeForm = sorActions.sorAddressForm.initAddressChangeForm;
  SmartOrderRefill.initOrderView = sorActions.sorOrderView.initOrderView;
  SmartOrderRefill.initUpdateCreditCardForm = sorActions.sorCreditCard.initCreditCardView;
  SmartOrderRefill.initCreditCardExpirationWarning = sorActions.sorCreditCard.initCreditCardExpirationWarning;
  SmartOrderRefill.initReactivateSubscriptionView = sorActions.sorReactivateSubscription.initReactivateSubscription;
  SmartOrderRefill.initResubscribeView = sorActions.sorResubscribe.initResubscribeView;
  SmartOrderRefill.initLoginFromCart = sorActions.sorCartPageLogin.loginFromCartPage;
  SmartOrderRefill.initProductDetailPageOptions = sorActions.sorManageRefillOptions.initProductDetailPageOptions;
  SmartOrderRefill.initQuickViewOptions = sorActions.sorManageRefillOptions.initQuickViewOptions;
  SmartOrderRefill.initChangeCartOptions = sorActions.sorManageRefillOptions.initChangeCartOptions;
  SmartOrderRefill.initLinkModal = sorActions.sorLinkModal.initLinkModal;
  SmartOrderRefill.initAccountSorView = sorActions.sorAccountView.initAccountView;
  SmartOrderRefill.initSGCheckout = sorActions.sorSGCheckout.initSGCheckout;
  SmartOrderRefill.initSwitchElement = sorActions.sorProduct.initSwitch;
  SmartOrderRefill.initToastMessage = sorActions.sorToastMessageShow.initToastMessage;
  SmartOrderRefill.init = sorHelpers.sorUtils.init;

  $(document).ready(function () {
    Object.keys(SmartOrderRefill).forEach(function (key) {
      // initialize functions
      SmartOrderRefill[key]();
    });
    window.SmartOrderRefill = SmartOrderRefill;
  });
})(window.jQuery);
